import React, { useState, Fragment } from 'react'
import { Button } from 'Components/Buttons/Button'
import { PickupHeaderWrapper } from './style'
import FileDownloadIcon from 'Assets/Images/icons/fileDownload'
import SearchAndFiltersWithCodeAutoComplete from './SearchAndFiltersWithCodeAutoComplete'
import PickupData from './PickupData'
import InventoryView from './InventoryView'
import { Link } from 'react-router-dom'
import { urlGet } from './../../../../../Utils/URL'
import injectStyles from 'react-jss'
import { urlSet, urlRemove } from './../../../../../Utils/URL'
import { downloadStringAsFile } from './../../../../../Utils/Misc'
import { escapeCsvString } from './../../../../../shared/csv'
import {
  formatToLocalDate,
  dropTimeZoneFromDate,
} from './../../../../../shared/libraries/utils/date'

const styles = {
  searchInputClassName: {
    '@global input': {
      backgroundColor: 'white',
    },
  },
}
const sanitizeStr = str => (str ? str.toLowerCase().trim() : str)

const View = ({
  clients,
  campaigns,
  brandAmbassadors,
  cityId,
  assignInventoryToUser,
  returnInventoryFromUser,
  classes,
  selectedTags,
  onSelectedTagsChange,
}) => {
  // Fake state to trigger a rerender. Starting to dislike hooks and React 😠
  var [, setDummyState] = useState()
  var rerender = () => setDummyState(+new Date())

  var clientHash = {}
  var campaignHash = {}
  var brandAmbassadorsHash = {}
  var selectedBrandAmbassadors = null
  var selectedCampaigns = null
  var selectedClients = null
  clients.forEach(o => (clientHash[sanitizeStr(o.name)] = o))
  campaigns.forEach(o => (campaignHash[sanitizeStr(o.name)] = o))
  brandAmbassadors.forEach(o => (brandAmbassadorsHash[sanitizeStr(o.name)] = o))
  selectedBrandAmbassadors = (() => {
    var key = urlGet('Ambassador')
    if (!key) return null
    return typeof key === 'string'
      ? [brandAmbassadorsHash[sanitizeStr(key)]]
      : key.map(key => brandAmbassadorsHash[sanitizeStr(key)])
  })()
  selectedCampaigns = (() => {
    var key = urlGet('Campaign')
    if (!key) return null
    const campaigns =
      typeof key === 'string'
        ? [campaignHash[sanitizeStr(key)]]
        : key.map(key => campaignHash[sanitizeStr(key)])
    return campaigns.filter(c => c)
  })()
  selectedClients = (() => {
    var key = urlGet('Client')
    if (!key) return null
    const clients =
      typeof key === 'string'
        ? [clientHash[sanitizeStr(key)]]
        : key.map(key => clientHash[sanitizeStr(key)])
    return clients.filter(c => c)
  })()
  var selectedMerchTypes =
    typeof urlGet('Merch Type') == 'string'
      ? [urlGet('Merch Type')]
      : urlGet('Merch Type')

  var [searchText, setSearchText] = useState(urlGet('search') || '')

  // Wraps a function that after that function runs triggers a rerender
  const rerenderAfter = func => (...args) => {
    func(...args)
    rerender()
  }

  // Wraps the setSearchText function to set the filter if a match is searched
  // for and found
  const maybeSetFilter = func => str => {
    // If user's search for a specific string that matches a filter option,
    // set that filter option
    var client = clientHash[str.toLowerCase().trim()]
    if (client) {
      return urlSet('Client', str)
    }
    var campaign = campaignHash[str.toLowerCase().trim()]
    if (campaign) {
      return urlSet('Campaign', str)
    }
    var brandAmbassador = brandAmbassadorsHash[str.toLowerCase().trim()]
    if (brandAmbassador) {
      return urlSet('Ambassador', str)
    }
    // Because we have manually opted to keep the url in sync we need to do it
    // here
    urlSet('search', str)
    return func(str)
  }

  return (
    <PickupHeaderWrapper>
      <PickupData
        cityId={cityId}
        brandAmbassadorIds={
          selectedBrandAmbassadors
            ? selectedBrandAmbassadors.map(o => o.id)
            : null
        }
        campaignIds={
          selectedCampaigns ? selectedCampaigns.map(o => o.id) : null
        }
        clientIds={selectedClients ? selectedClients.map(o => o.id) : null}
        searchText={searchText}
      >
        <InnerView
          assignInventoryToUser={assignInventoryToUser}
          returnInventoryFromUser={returnInventoryFromUser}
          classes={classes}
          setSearchText={setSearchText}
          rerenderAfter={rerenderAfter}
          maybeSetFilter={maybeSetFilter}
          brandAmbassadors={brandAmbassadors}
          selectedBrandAmbassadors={selectedBrandAmbassadors}
          campaigns={campaigns}
          selectedCampaigns={selectedCampaigns}
          clients={clients}
          selectedClients={selectedClients}
          searchText={searchText}
          selectedTags={selectedTags}
          onSelectedTagsChange={onSelectedTagsChange}
          cityId={cityId}
          selectedMerchTypes={selectedMerchTypes}
        />
      </PickupData>
    </PickupHeaderWrapper>
  )
}

const InnerView = ({
  assignInventoryToUser,
  returnInventoryFromUser,
  classes,
  setSearchText,
  rerenderAfter,
  maybeSetFilter,
  brandAmbassadors,
  selectedBrandAmbassadors,
  campaigns,
  selectedCampaigns,
  clients,
  selectedClients,
  searchText,
  selectedTags,
  onSelectedTagsChange,
  cityId,
  selectedMerchTypes,
  givenOutCodes,
  availableCodes,
  updateLocalInventoryState,
  ...otherProps
}) => {
  const handlePickupBrief = () => {
    if (!otherProps.missions) return alert('Please wait, still loading data.')
    var csvContent = `Name,Phone Number,Email,Pickup Time\n`
    otherProps.missions.forEach(m => {
      csvContent +=
        [
          escapeCsvString(m['AMBASSADOR'] || ''),
          escapeCsvString(m['ambassadorMobilePhone'] || ''),
          escapeCsvString(m['ambassadorEmail'] || ''),
          escapeCsvString(
            m['SCHEDULED PICKUP TIME']
              ? formatToLocalDate(
                  new Date(dropTimeZoneFromDate(m['SCHEDULED PICKUP TIME'])),
                )
              : '',
          ),
        ].join(',') + '\n'
    })
    downloadStringAsFile(csvContent, 'pickup-brief.csv')
  }
  const merchNames = [
    'Aprons N/A',
    'Aprons XS',
    'Aprons S',
    'Aprons M',
    'Aprons L',
    'Aprons XL',
    'Aprons XXL',
    'Aprons XXXL',
    'Aprons XXXXL',

    'Backpacks N/A',
    'Backpacks XS',
    'Backpacks S',
    'Backpacks M',
    'Backpacks L',
    'Backpacks XL',
    'Backpacks XXL',
    'Backpacks XXXL',
    'Backpacks XXXXL',

    'Badge N/A',
    'Badge XS',
    'Badge S',
    'Badge M',
    'Badge L',
    'Badge XL',
    'Badge XXL',
    'Badge XXXL',
    'Badge XXXXL',

    'Beanie N/A',
    'Beanie XS',
    'Beanie S',
    'Beanie M',
    'Beanie L',
    'Beanie XL',
    'Beanie XXL',
    'Beanie XXXL',
    'Beanie XXXXL',

    'Gloves N/A',
    'Gloves XS',
    'Gloves S',
    'Gloves M',
    'Gloves L',
    'Gloves XL',
    'Gloves XXL',
    'Gloves XXXL',
    'Gloves XXXXL',

    'Hat N/A',
    'Hat XS',
    'Hat S',
    'Hat M',
    'Hat L',
    'Hat XL',
    'Hat XXL',
    'Hat XXXL',
    'Hat XXXXL',

    'Jumpers N/A',
    'Jumpers XS',
    'Jumpers S',
    'Jumpers M',
    'Jumpers L',
    'Jumpers XL',
    'Jumpers XXL',
    'Jumpers XXXL',
    'Jumpers XXXXL',

    'Polos N/A',
    'Polos XS',
    'Polos S',
    'Polos M',
    'Polos L',
    'Polos XL',
    'Polos XXL',
    'Polos XXXL',
    'Polos XXXXL',

    'Rainjackets N/A',
    'Rainjackets XS',
    'Rainjackets S',
    'Rainjackets M',
    'Rainjackets L',
    'Rainjackets XL',
    'Rainjackets XXL',
    'Rainjackets XXXL',
    'Rainjackets XXXXL',

    'Shorts N/A',
    'Shorts XS',
    'Shorts S',
    'Shorts M',
    'Shorts L',
    'Shorts XL',
    'Shorts XXL',
    'Shorts XXXL',
    'Shorts XXXXL',

    'T-shirt N/A',
    'T-shirt XS',
    'T-shirt S',
    'T-shirt M',
    'T-shirt L',
    'T-shirt XL',
    'T-shirt XXL',
    'T-shirt XXXL',
    'T-shirt XXXXL',

    'Totes Bag N/A',
    'Totes Bag XS',
    'Totes Bag S',
    'Totes Bag M',
    'Totes Bag L',
    'Totes Bag XL',
    'Totes Bag XXL',
    'Totes Bag XXXL',
    'Totes Bag XXXXL',
  ]
  return (
    <Fragment>
      <div className="title-wrapper">
        <h3 className="title">Pickup</h3>

        <Link to="manage-pickup-times" className="button-link">
          <Button>Manage Pickup times</Button>
        </Link>
      </div>
      <div className="filter-wrapper">
        <div className="filter-left">
          <SearchAndFiltersWithCodeAutoComplete
            filters={[
              {
                label: 'Ambassador',
                values: brandAmbassadors.map(a => a.name).sort(),
                onChange: rerenderAfter(str =>
                  str ? urlSet('Ambassador', str) : urlRemove('Ambassador'),
                ),
                selectedValue: selectedBrandAmbassadors
                  ? selectedBrandAmbassadors.map(o => o.name)
                  : null,
              },
              {
                label: 'Client',
                values: clients.map(c => c.name).sort(),
                onChange: rerenderAfter(str =>
                  str ? urlSet('Client', str) : urlRemove('Client'),
                ),
                selectedValue: selectedClients
                  ? selectedClients.map(o => o.name)
                  : null,
              },
              {
                label: 'Campaign',
                values: campaigns.map(c => c.name).sort(),
                onChange: rerenderAfter(str =>
                  str ? urlSet('Campaign', str) : urlRemove('Campaign'),
                ),
                selectedValue: selectedCampaigns
                  ? selectedCampaigns.map(o => o.name)
                  : null,
              },
              {
                label: 'Merch Type',
                values: merchNames || [],
                sorted: false,
                onChange: rerenderAfter(str =>
                  str ? urlSet('Merch Type', str) : urlRemove('Merch Type'),
                ),
                selectedValue: selectedMerchTypes,
              },
            ]}
            onSearchTextChange={rerenderAfter(/*maybeSetFilter*/ setSearchText)}
            searchInputClassName={classes.searchInputClassName}
            selectedTags={selectedTags}
            allCodes={(givenOutCodes || [])
              .map(o => o.code)
              .concat((availableCodes || []).map(o => o.code))}
            onSelectedTagsChange={onSelectedTagsChange}
            cityId={cityId}
          />
        </div>
        <div className="clear-button">
          <Button onClickHandler={handlePickupBrief}>
            <FileDownloadIcon />
            Pickup Brief
          </Button>
        </div>
      </div>
      <div>
        <InventoryView
          updateLocalInventoryState={updateLocalInventoryState}
          brandAmbassadors={
            selectedBrandAmbassadors
              ? selectedBrandAmbassadors
              : brandAmbassadors
          }
          clients={(() => {
            var theClients = selectedClients ? selectedClients : clients
            if (selectedCampaigns) {
              return theClients.filter(client =>
                selectedCampaigns.find(cam => cam.client.id == client.id),
              )
            } else {
              return theClients
            }
          })()}
          campaigns={selectedCampaigns ? selectedCampaigns : campaigns}
          assignInventoryToUser={assignInventoryToUser}
          returnInventoryFromUser={returnInventoryFromUser}
          selectedTags={selectedTags}
          selectedMerch={selectedMerchTypes}
          givenOutCodes={givenOutCodes}
          availableCodes={availableCodes}
          {...otherProps}
        />
      </div>
    </Fragment>
  )
}

export default injectStyles(styles)(View)



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/new/View.js